import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { deepCopy } from 'na-lib';
import { CommentsService } from '../../service/comments.service';
import { operatorOptions, typeOptions } from 'na-lib';

@Component({
    selector: 'app-report-filter-settings-dialog',
    templateUrl: './report-filter-settings-dialog.component.html',
    styleUrls: ['./report-filter-settings-dialog.component.css'],
    standalone: false
})
export class ReportFilterSettingsDialogComponent {

  filterForm!:FormGroup
  type:any
  selectedType: string;
  reportTemplate: any;
  filtersValues:any

  panelOpenState = false;
  typeOptions = typeOptions
  operatorOptions = operatorOptions

  constructor(
    public dialogRef: MatDialogRef<ReportFilterSettingsDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commentsService:CommentsService,
  ){
    dialogRef.disableClose = true;
  }

  ngOnInit(){
    this.reportTemplate = this.data
    this.filterForm= this.fb.group({})

    this.initializeFiltersForm()
  }

  onCancel(){
    this.dialogRef.close([this.filterForm.value, false])
  }

  checkFilterTypeOperatorRange(filter, type){
    if(filter == 'string' || filter == 'boolean' || filter == 'media'){
      if(type.value == 'inrange'){
        return true
      }else
      return false
    }else
    return false
  }

  initializeFiltersForm(){
    if(this.reportTemplate){
      if(this.reportTemplate.filters){
        const filters = deepCopy(this.reportTemplate.filters)
        filters.forEach((filter, index) => {
          if(filter.key){
            const key = index + '_' + filter.key
            if(this.filtersValues && this.filtersValues[filter.key]){
              this.filterForm.addControl(filter.key,new FormControl(this.filtersValues[filter.key]))
            }else{
              this.filterForm.addControl(filter.key,new FormControl(undefined))
            }
            const name = filter.key + '_operator'
            this.filterForm.addControl(name,new FormControl(filter.operator, Validators.required))

            const nametype = filter.key + '_type'
            this.filterForm.addControl(nametype,new FormControl(filter.type, Validators.required))

            const nameDisplayName = filter.key + '_displayName'
            this.filterForm.addControl(nameDisplayName,new FormControl(filter.displayName, Validators.required))

            const nameKey = filter.key + '_key'
            this.filterForm.addControl(nameKey,new FormControl(filter.key, Validators.required))

            const nameDescription = filter.key + '_description'
            this.filterForm.addControl(nameDescription,new FormControl(filter.description))
              
            const nameOptions = filter.key + '_options'
            let options = []
            if(filter.options)
              options = filter.options
            this.filterForm.addControl(nameOptions,new FormControl(options))

            const nameNewOption = filter.key + '_newOption'
            this.filterForm.addControl(nameNewOption,new FormControl(undefined))
          }
        });
      }
    }
  }

  clearFilters(){
    const filters = deepCopy(this.reportTemplate.filters)
      filters.forEach(filter => {
        if(filter.key){
          this.filterForm.setControl(filter.key,new FormControl(undefined))
          const name = filter.key + '_operator'
          this.filterForm.setControl(name,new FormControl(filter.operator))
          const nametype = filter.key + '_type'
          this.filterForm.setControl(nametype,new FormControl(filter.type))
        }
      });
  }

  deleteOptionFilter(filter,  option,optionIndex){
    let options = this.filterForm.value[filter.key+'_options']
    options.splice(optionIndex, 1)
    this.filterForm.patchValue({[filter.key+'_options']: options})
  }

  addOptionFilter(filter){
    const value = this.filterForm.value[filter.key+'_newOption']
    let options = this.filterForm.value[filter.key+'_options']
    options.push(value)
    this.filterForm.patchValue({[filter.key+'_options']: options, [filter.key+'_newOption']: undefined})
  }

  onSave(){

    this.commentsService.progressSpin.emit(true)

    const firstFilters = deepCopy(this.reportTemplate.filters)
    const form = deepCopy(this.filterForm.value)

    let newFiltersTemplate = []
    firstFilters.forEach((filter, index) => {

      if(filter.key){
        if(form[filter.key+'_key']){
          const key = this.filterForm.value[filter.key+'_key'] ? this.filterForm.value[filter.key+'_key'] : filter.key
          const description = this.filterForm.value[filter.key+'_description'] ? this.filterForm.value[filter.key+'_description'] : undefined
          const displayName = this.filterForm.value[filter.key+'_displayName']  ? this.filterForm.value[filter.key+'_displayName']  : filter.displayName
          const operator = this.filterForm.value[filter.key+'_operator'] ? this.filterForm.value[filter.key+'_operator'] : filter.operator
          const type = this.filterForm.value[filter.key+'_type'] ?  this.filterForm.value[filter.key+'_type'] :  filter.type
          const options = this.filterForm.value[filter.key+'_options'] ? this.filterForm.value[filter.key+'_options'] :  filter.options

          const newFilter = { key,  displayName, operator, type }

          if(description)
            newFilter['description'] = description

          if(options?.length>0 && (operator=='=' || operator=='!='))
            newFilter['options'] = options

          if(options?.length>0 && operator!='=' && operator!='!=')
            this.filterForm.patchValue({[filter.key+'_options']:[]})

          if(key && displayName && operator && type)
            newFiltersTemplate.push(newFilter)
        
        }
      }
    })

    this.dialogRef.close([newFiltersTemplate, true])
  }

}
